require('./bootstrap');

window.document.querySelectorAll('form').forEach(form => {
    form.onsubmit = e => {
        form.querySelectorAll('[type="submit"]').forEach(submitBtn => {
            submitBtn.setAttribute('disabled', 'true');
        })
    }
});

window.$(()=>{
    // on first focus (bubbles up to document), open the menu
    window.$(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
        const select = window.$(this).closest(".select2-container").siblings('select:enabled');
        if(!select.data('open')){
            select.select2('open');
            select.data('open', true);
            console.log('opening');
        } else {
            select.data('open', false);
            console.log('closing');
        }
    });
})
